import * as Yup from "yup";

const emailRecuperarSenhaValidator = Yup.string("E-mail")
  .email("E-mail")
  .required("E-mail");

export default emailRecuperarSenhaValidator;
